import { navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">爆料网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              本站为爆料网的入口导航页，汇总官网入口、最新可用地址与 App 下载方式，帮助用户快速定位官方地址、
              避免误入仿冒站点。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">本页导航</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={`#${link.id}`} className="text-background-200 transition-colors hover:text-background-50">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">温馨提示</h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200">
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-300" aria-hidden="true" />
                只使用自己收藏的官方地址访问
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-300" aria-hidden="true" />
                不点击陌生私信与群聊链接
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-300" aria-hidden="true" />
                不填写账号、验证码与支付信息
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆料网入口导航 · 本页内容仅作地址整理与说明用途</p>
          <p>请以官方公告为准，理性辨别信息来源</p>
        </div>
      </div>
    </footer>
  );
}